import { Link } from 'react-router-dom';

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-emerald-950 py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm font-inter mb-6 transition-colors">
            <i className="ri-arrow-left-line" />
            Voltar ao início
          </Link>
          <h1 className="font-sora font-bold text-3xl md:text-4xl text-white">
            Termos de Uso
          </h1>
          <p className="font-inter text-emerald-100/60 text-sm mt-3">
            Última atualização: 17 de abril de 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="prose prose-zinc max-w-none font-inter text-zinc-600 leading-relaxed [&_h2]:font-sora [&_h2]:font-bold [&_h2]:text-zinc-900 [&_h2]:text-xl [&_h2]:mt-10 [&_h2]:mb-4 [&_p]:mb-4 [&_ul]:mb-4 [&_li]:mb-1.5 [&_a]:text-emerald-600 [&_a]:underline [&_strong]:text-zinc-800">

          <p>
            Bem-vindo à <strong>Almadata Soluções Tecnológicas</strong>. Ao acessar ou utilizar nosso site e serviços, você concorda com estes Termos de Uso. Caso não concorde, não utilize nossos serviços.
          </p>

          <h2>1. Definições</h2>
          <p>
            <strong>Usuário:</strong> pessoa física ou jurídica que acessa o site ou contrata serviços da Almadata.<br />
            <strong>Empresa:</strong> Almadata Soluções Tecnológicas, responsável pelo desenvolvimento e operação dos serviços.
          </p>

          <h2>2. Objeto</h2>
          <p>
            Estes Termos regulam o uso do site e a prestação de serviços de consultoria estratégica, engenharia de software e inteligência artificial oferecidos pela Almadata, incluindo diagnósticos de modelo de negócio, propostas de implementação, desenvolvimento de soluções tecnológicas e acompanhamento de métricas.
          </p>

          <h2>3. Aceitação</h2>
          <p>
            Ao usar o site ou contratar nossos serviços, você declara ter lido, entendido e aceitado integralmente estes Termos de Uso e nossa <Link to="/privacy-policy" className="text-emerald-600 underline">Política de Privacidade</Link>.
          </p>

          <h2>4. Serviços</h2>
          <p>
            A Almadata oferece serviços estruturados em fases (Diagnóstico Estratégico, Proposta de Implementação, Execução e Métrica), cada uma com contrato próprio, escopo fechado e entregáveis definidos. Os detalhes de escopo, prazos e valores são formalizados em contrato específico para cada fase.
          </p>

          <h2>5. Uso do Site</h2>
          <p>O Usuário concorda em não utilizar o site para fins ilícitos ou que violem estes Termos, incluindo:</p>
          <ul>
            <li>Realizar engenharia reversa, cópia ou distribuição não autorizada de conteúdo;</li>
            <li>Inserir conteúdos ilegais, ofensivos ou discriminatórios em formulários;</li>
            <li>Violar direitos de propriedade intelectual da Empresa ou de terceiros;</li>
            <li>Tentativas de acesso não autorizado a sistemas, dados ou áreas restritas.</li>
          </ul>

          <h2>6. Propriedade Intelectual</h2>
          <p>
            Todo o conteúdo do site — incluindo marca, logotipo, código-fonte, textos, design e metodologia — é de propriedade exclusiva da Almadata, sendo vedada sua reprodução ou utilização sem autorização prévia. Os entregáveis produzidos em contratos de prestação de serviço são de propriedade do cliente, conforme definido em cada contrato.
          </p>

          <h2>7. Privacidade e Proteção de Dados</h2>
          <p>
            Tratamos seus dados pessoais conforme a Lei Geral de Proteção de Dados (LGPD — Lei 13.709/2018). Para detalhes, consulte nossa <Link to="/privacy-policy" className="text-emerald-600 underline">Política de Privacidade</Link>.
          </p>

          <h2>8. Limitação de Responsabilidade</h2>
          <p>A Almadata não se responsabiliza por:</p>
          <ul>
            <li>Eventuais indisponibilidades ou falhas temporárias do site;</li>
            <li>Resultados de negócio que dependam de fatores externos à implementação técnica;</li>
            <li>Danos indiretos ou lucros cessantes resultantes do uso ou impossibilidade de uso do site;</li>
            <li>Custos de infraestrutura, serviços externos, modelos de linguagem e recursos computacionais após o término do contrato.</li>
          </ul>

          <h2>9. Alterações dos Termos</h2>
          <p>
            Estes Termos poderão ser atualizados periodicamente. Recomendamos que o Usuário os revise com frequência. As alterações entrarão em vigor após publicação nesta página, com data revisada.
          </p>

          <h2>10. Legislação Aplicável e Foro</h2>
          <p>
            Estes Termos são regidos pela legislação brasileira, em especial pela LGPD. Fica eleito o foro da comarca de São Roque/SP para dirimir eventuais conflitos.
          </p>

          <h2>11. Contato</h2>
          <p>
            Para dúvidas sobre estes Termos, entre em contato pelo e-mail <a href="mailto:contato@almadata.com.br">contato@almadata.com.br</a> ou pelo telefone +55 (61) 99223-2205.
          </p>

        </div>
      </div>
    </div>
  );
}
